import Vue from 'vue'
import Vuex, { StoreOptions, ActionContext } from 'vuex';

const module = { 
  namespaced: true, // 지정을 해줘야 RootState와 따로 동작한다. 없으면, RootState 변경시 같이 변경 
  state: { 
    data: '',  //RootState와 똑같이 작성해도 된다. 
    dataprovider:  {} 
  },
  mutations: { 
    addDataprovider(state, data){
      state.dataprovider = JSON.parse(localStorage.getItem('dataprovider')) || {};
      state.dataprovider = Object.assign(state.dataprovider, data)
      localStorage.setItem('dataprovider', JSON.stringify(state.dataprovider));
    },
    /*
    removeDataprovider(state, data){
      state.employee = null; 
      localStorage.removeItem('currentEmployee');
    },
    */
  },
  actions: {
    addDataprovider({commit}, data) {
      commit('addDataprovider', data);
    },
  },
  getters: { 
    dataprovider: function(state){
      
      state.dataprovider = JSON.parse(localStorage.getItem('dataprovider') || null);

      return state.dataprovider;
    },
  }
}
export default module;